module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_chapel_2-1977a7b1e66dc8301a9803529416e581.jpg";